import styled from 'styled-components';


export const Wrapper = styled.div`
  .single-col {
    display: grid;
    grid-template-columns: 1fr;
  }
`;

export const Content = styled.div`
  width: 85%;
  margin: 40px auto;
`;

export const ContentRow = styled.div`
  display: grid;
  grid-template-columns: 2fr 3fr;
  margin: 40px 0 65px;
  grid-column-gap: 4%;

  h1 {
    text-align: center;
    text-transform: uppercase;
    font-size: 30px;
    font-weight: 900;
    font-style: italic;
    color: white;
    margin: 0;

    span {
      color: #ff0033;
    }
  }

  @media all and (max-width: 1200px) {
    display: flex;
    flex-direction: column;
  }
`;

export const ContentCol = styled.div`
  display: grid;
  grid-row-gap: 40px;

  @media all and (max-width: 1200px) {
    width: 100%;
    margin: 1em 0;

    h1 {
      font-size: 22px;
    }
  }
  
`;



// WEBPACK FOOTER //
// ./src/pages/Students/DataCentre/DataCentre.styles.ts